import { render, staticRenderFns } from "./DedicatePage4.vue?vue&type=template&id=f29a9e48&scoped=true&"
import script from "./DedicatePage4.vue?vue&type=script&lang=js&"
export * from "./DedicatePage4.vue?vue&type=script&lang=js&"
import style0 from "./DedicatePage4.vue?vue&type=style&index=0&id=f29a9e48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29a9e48",
  null
  
)

export default component.exports